import React from 'react';
import { Grid } from 'semantic-ui-react';
import TabHeader from '@/components/tabs/TabHeader';
import SelectCohortDatasets from '../containers/SelectCohortDatasets';
import SelectCohortDictionaries from '../containers/SelectCohortDictionaries';

const SelectCohortSource = ({ category, code }) => (
  <Grid>
    <Grid.Row columns="equal">
      <Grid.Column>
        <TabHeader headerId="cohort.select.source" icon="chevron right" />
      </Grid.Column>
      <Grid.Column />
    </Grid.Row>
    <Grid.Row columns="equal">
      <Grid.Column>
        <SelectCohortDatasets code={code} category={category} />
      </Grid.Column>
      <Grid.Column>
        <SelectCohortDictionaries code={code} category={category} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default SelectCohortSource;
